import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacySk3() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`III.`}
            <br />
            {`Uzatvorenie zmluvy`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Návrh na uzatvorenie zmluvy o poskytovaní prístupu do služby uskutoční používateľ vyplnením údajov v registračnom formulári používateľského účtu, súhlasom s týmito obchodnými podmienkami a odoslaním týchto údajov poskytovateľovi (ďalej len „objednávka“). `}</li>
            <li>{`Po doručení objednávky a po úhrade príslušnej služby či prvého obdobia služby poskytovateľ umožní používateľovi prístup k webovej stránke, t. j. prístup k zvolenému obsahu.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={3} className={sList}>
            <li>{`Poskytovateľ je oprávnený odmietnuť objednávku používateľa, a to predovšetkým od osôb, ktoré už skôr podstatným spôsobom porušili zmluvy s poskytovateľom či tieto obchodné podmienky.`}</li>
            <li>{`Poskytovateľ je oprávnený postúpiť práva a povinnosti zo zmluvy na tretiu osobu, a to aj bez súhlasu používateľa.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacySk3;
